import"react";var a;!function(a){a.Valid="valid",a.Validating="validating",a.Error="error"}(a||(a={}));export{a as StateType};
//# sourceMappingURL=use-form-field.hook.js.map
